
import { call, put, select } from 'redux-saga/effects'
import request from '@src/utility/request'
import { 
    loadForm302RouteSuccess,
    loadForm302RouteFail,
    loadForm302Route,
    publishForm302RouteSuccess,
    publishForm302RouteFail,
    updateForm302StepCordsSuccess,
    updateForm302StepCordsFail,
    updateForm302RoutePanZoomFail,
    updateForm302RoutePanZoomSuccess,
    addForm302RouteStepSuccess,
    addForm302RouteStepFail,
    deleteForm302RouteStepSuccess,
    deleteForm302RouteStepFail
} from '../../actions/form302'
import { selectBaseUrl, selectLocale } from '../../selectors/config'
import { selectToken } from '../../selectors/auth'
import { toast, Slide } from 'react-toastify'
import ToastContent from '../../../components/Toast'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

// worker Saga: will be fired on TABLE_LOAD_DATA action
export function* fetchForm302(params) {
    const { passportId, callback } = params
    const requestURL = yield select(selectBaseUrl())
    const dataURL = 'form302'
    const locale = yield select(selectLocale())
    const token = yield select(selectToken())

    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"application/json",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }
    
     
    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        mode:'cors',
        credentials:'include'
    }

    try {
        
        const res = yield call(request, `${requestURL}${dataURL}/${passportId}`, requestOptions)
        
        if (res.data) {
            
            yield put(loadForm302RouteSuccess(res.data))

        } else {
            yield put(loadForm302RouteFail(form302ID, res.data))
        }

        if (callback) yield callback()
      
    } catch (e) {
       yield put(loadForm302RouteFail(passportId, [{message: e.message}]))
    }
}

// worker Saga: will be fired on ADD_STEP action
export function* addForm302Step(params) {
    const { identifier, data } = params
    const requestURL = yield select(selectBaseUrl())
    const locale = yield select(selectLocale())
    const dataURL = "form302RouteStepCreate"
    const token = yield select(selectToken())

    const myHeaders = {
        Accept: "application/json",
        "Content-Type":"multipart/form-data",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }

    /*eslint-disable */
    let formdata = new FormData()
    for (let k in data) {

        if (data[k].toString.call(data[k]).slice(8, -1) === 'FileList'){
            if ( data[k].length > 0) formdata.append(k, data[k][0], data[k][0].name)
        }
        else if(data[k].length && data[k].map){
            data[k].map((item) => {
                formdata.append(k, item)
            })
        }
        else if (data[k] !== undefined && data[k] !== null && data[k] !== '') {
            formdata.append(k, data[k]);
        }
        // else if(data[k]) formdata.append(k, data[k])

    }
    /*eslint-enable */

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        data:formdata,
        mode:'cors',
        credentials:'include'
    }

    try {

        const res = yield call(request, `${requestURL}${dataURL}/`, requestOptions)
        console.log("form step res", res)

        if (res.data?.id) {
            yield put(addForm302RouteStepSuccess(res.data))
            // yield put(loadStepsData(res.data.refProductRoute[0].identifier))
        } else {
            toast.error(
                <ToastContent type="error" title="Oops!" body={res.data?.message} />,
                { transition: Slide, hideProgressBar: true }
            )
            yield put(addForm302RouteStepFail(res.data))
        }

    } catch (e) {
       yield put(addForm302RouteStepFail([{message: e.message}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}

// worker Saga: will be fired on DELETE_FORM302_ROUTE_STEP action
export function* deleteForm302RouteStep(params) {
    const { id, identifier } = params

    const requestURL = yield select(selectBaseUrl())
    const locale = yield select(selectLocale())
    const dataURL = "form302RouteStepDelete"
    const token = yield select(selectToken())

    const myHeaders = {
        Accept: "application/json",
        "Content-Type":"multipart/form-data",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }

    const requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        mode:'cors',
        credentials:'include'
    }

    try {

        const res = yield call(request, `${requestURL}${dataURL}/${id}`, requestOptions)

        if (res.data.toString().indexOf('success') > 0) {
            yield put(deleteForm302RouteStepSuccess(id))
            yield put(loadForm302Route(identifier))
        } else {
            yield put(deleteForm302RouteStepFail(id, res.data))
            toast.error(
                <ToastContent type="error" title="Ooops!" body={ res.data?.message} />,
                    { transition: Slide, hideProgressBar: true }
                )
        }


    } catch (e) {
       yield put(deleteForm302RouteStepFail(id, [{message: e.message}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}

// worker Saga: will be fired on UPDATE_STEP_CORDS action
export function* updateFomr302RouteStepCords(params) {
  const { id, data } = params
  const requestURL = yield select(selectBaseUrl())
  const locale = yield select(selectLocale())
  const dataURL = "Form302RouteStepUpdateCords"
  const token = yield select(selectToken())
  
  const myHeaders = { 
      Accept: "application/json",
      "Content-Type":"multipart/form-data",
      "Accept-Language":locale,
      "User-Agent": "AFTS Web App",
      Authorization: `Token ${token}`,
      Origin : "*"
  }

  /*eslint-disable */
  let formdata = new FormData()
  for (let k in data) {
     
     
      if (data[k].toString.call(data[k]).slice(8, -1) === 'FileList'){
          console.log(k)
          if ( data[k].length > 0) formdata.append(k, data[k][0], data[k][0].name)
      } 
      else if(data[k].length && data[k].map){
          data[k].map((item) => {
              formdata.append(k, item)
          })
      }
      else if( data[k]!== null) formdata.append(k, data[k])
  
  }
  /*eslint-enable */

   
  const requestOptions = {
      method: 'PATCH',
      headers: myHeaders,
      data:formdata,
      mode:'cors',
      credentials:'include'
  }

  try {
      
      const res = yield call(request, `${requestURL}${dataURL}/${id}`, requestOptions)
      
      if (res.data?.id) {
          yield put(updateForm302StepCordsSuccess(id, res.data))
          if (res.data?.refProductRoute[0]?.identifier) {
            yield put(loadForm302Route(res.data.refForm302Route[0].identifier))
          }
      } else yield put(updateForm302StepCordsFail(id, res.data))
      
    
  } catch (e) {
     yield put(updateForm302StepCordsFail(id, [{message: e.message}]))

     toast.error(
      <ToastContent type="error" title="Ooops!" body={e.message} />,
      { transition: Slide, hideProgressBar: true }
      )
  }
}

// worker Saga: will be fired on PUBLISH_ROUTE action
export function* publishRoute(params) {
    const { identifier } = params
    const requestURL = yield select(selectBaseUrl())
    const locale = yield select(selectLocale())
    const dataURL = "form302RoutePublish"
    const token = yield select(selectToken())
    
    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"multipart/form-data",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        data:{},
        mode:'cors',
        credentials:'include'
    }

    try {
        
        const res = yield call(request, `${requestURL}${dataURL}/${identifier}`, requestOptions)
        
        if (res.data?.IPFS_hash) {
            
            yield put(publishForm302RouteSuccess(identifier))

            MySwal.fire({
                title: 'Hurray!',
                text: 'Route has been published successfully!',
                icon: 'success',
                customClass: {
                  confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false
            })

        } else yield put(publishForm302RouteFail(identifier, res.data))
        
      
    } catch (e) {
       yield put(publishForm302RouteFail(identifier, [{message: e.message}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}

// worker Saga: will be fired on REQUEST_STEP_DATA action
export function* requestStepData(params) {
    const { stepId, data } = params
    const requestURL = yield select(selectBaseUrl())
    const locale = yield select(selectLocale())
    const dataURL = "stepDataRequest"
    const token = yield select(selectToken())
    
    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"multipart/form",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }

    /*eslint-disable */
     let formdata = new FormData()
     for (let k in data) {
        
        
         if (data[k].toString.call(data[k]).slice(8, -1) === 'FileList'){
             console.log(k)
             if ( data[k].length > 0) formdata.append(k, data[k][0], data[k][0].name)
         } 
         else if(data[k].length && data[k].map){
             data[k].map((item) => {
                 formdata.append(k, item)
             })
         }
         else if( data[k]!== null) formdata.append(k, data[k])
     
    }
    /*eslint-enable */

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        data: formdata,
        mode:'cors',
        credentials:'include'
    }

    try {
        
        const res = yield call(request, `${requestURL}${dataURL}/${stepId}`, requestOptions)
        
        if (res.data === "Email was sent sucessfully") {
            
            yield put(requestStepDataSuccess(stepId))

            MySwal.fire({
                title: 'Hurray!',
                text: res.data,
                icon: 'success',
                customClass: {
                  confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false
            })

        } else {
            yield put(requestStepDataFail(stepId, res.data))
            toast.error(
                <ToastContent type="error" title="Ooops!" body={res.data} />,
                { transition: Slide, hideProgressBar: true }
            )
        }
        
      
    } catch (e) {
       yield put(requestStepDataFail(stepId, [{message: e.message}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}

// worker Saga: will be fired on UPDATE_ROUTE_PAN_ZOOM action
export function* updateForm302RoutePanZoom(params) {
  const { identifier, data } = params
  const requestURL = yield select(selectBaseUrl())
  const locale = yield select(selectLocale())
  const dataURL = "updateForm302RoutePanZoom"
  const token = yield select(selectToken())
  
  const myHeaders = { 
      Accept: "application/json",
      "Content-Type":"application/json",
      "Accept-Language":locale,
      "User-Agent": "AFTS Web App",
      Authorization: `Token ${token}`,
      Origin : "*"
  }

  const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      data:{data},
      mode:'cors',
      credentials:'include'
  }

  try {
      const res = yield call(request, `${requestURL}${dataURL}/${identifier}`, requestOptions)
      
      if (res.data) {
        yield put(updateForm302RoutePanZoomSuccess(identifier))
      } else yield put(updateForm302RoutePanZoomFail(identifier, res.data))
    
  } catch (e) {
      yield put(updateForm302RoutePanZoomFail(identifier, [{message: e.message}]))
  }
}

// worker Saga: will be fired on PUBLISH_ROUTE action
export function* publishForm302Route(params) {

    const { identifier } = params
    const requestURL = yield select(selectBaseUrl())
    const dataURL = 'publishForm302Route'
    const locale = yield select(selectLocale())
    const token = yield select(selectToken())

    const myHeaders = {
        Accept: "application/json",
        "Content-Type":"application/json",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        mode:'cors',
        credentials:'include'
    }

    try {

        const res = yield call(request, `${requestURL}${dataURL}/${identifier}`, requestOptions)

        // if (res.data?.IPFS_hash) {
        if (res?.data?.id) {

            yield put(publishForm302RouteSuccess(res?.data?.id))
            yield put(loadForm302Route(res?.data?.id))

            MySwal.fire({
                title: 'Success!',
                text: 'You successfully signed all F302 document copies.',
                icon: 'success',
                customClass: {
                  confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false
            })

        } else {
            yield put(publishForm302RouteFail(identifier, res.data))

            toast.error(
                <ToastContent type="error" title="Ooops!" body={res?.data?.message} />,
                { transition: Slide, hideProgressBar: true }
            )
        }


    } catch (e) {
       yield put(publishForm302RouteFail(identifier, [{message: e.message}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}